import TipoOcorrenciaSucesso from '@/model/resource/TipoOcorrenciaSucesso'
import {ResponseSerialize} from 'simpli-web-sdk'
import StatusNotificacaoAuditoria from '@/model/resource/StatusNotificacaoAuditoria'
import {Exclude} from 'class-transformer'

export class CargaInfo {
  idCargaFk: number | null = null
  croCte: string | null = null
  manifesto: string | null = null
  idTipoNotificacaoFk: number | null = null
  nroCte: string | null = null

  @ResponseSerialize(TipoOcorrenciaSucesso)
  tipoOcorrenciaSucesso: TipoOcorrenciaSucesso | null = null

  listaDeAvarias: string | null = null

  @ResponseSerialize(StatusNotificacaoAuditoria)
  statusNotificacaoAuditoria: StatusNotificacaoAuditoria | null = null

  @Exclude()
  notificacaoSmsAtlas: string | null = null

  @Exclude()
  notificacaoEmailAtlas: string | null = null

  observacaoEntrega: string | null = null
  idNotificacaoCarga: string | null = null
  nomeNotification: string | null = null
  dataPrevisaoAtualizada: string | null = null
  observacaoPrevisao: string | null = null
}
